<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <h1>{{ translate('messages.wa_messager') }}</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div v-if="sent">
                                <div class="alert alert-success" role="alert">
                                    {{ translate('messages.message_sent') }}
                                </div>
                                <div class="pb-2">
                                    <strong>{{ translate('messages.message') }}:</strong> {{ message }}
                                </div>
                                <div style="max-height: 500px; overflow: auto;">
                                    <table class="table table-stripped">
                                        <thead>
                                            <tr>
                                                <th>{{ translate('messages.country_calling_code') }}</th>
                                                <th>{{ translate('messages.phone') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(field, index) in fields" :key="index">
                                                <td>{{ field.country_calling_code }}</td>
                                                <td>{{ field.phone }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="text-center">
                                    <button class="btn btn-secondary" @click="resetForm">{{
                                        translate('messages.send_another_message')
                                    }}</button>
                                </div>
                            </div>
                            <div v-else>
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="card wa-phone-numbers">
                                            <div class="card-header">
                                                <h3 class="card-title">{{ translate('messages.phones') }}</h3>
                                            </div>
                                            <div class="card-body p-1">
                                                <div v-for="(field, index) in fields" :key="index">
                                                    <div class="form-group mb-1">
                                                        <div class="input-group">
                                                            <v-select class="form-control p-0 country-calling-code-select"
                                                                :options="countries" v-model="field.country_calling_code"
                                                                :option:selected="removeError(index, 'country_calling_code')"
                                                                :reduce="(option) => option.key" :clearable="false"
                                                                :placeholder="translate('messages.country_calling_code')"
                                                                :class="{ 'is-invalid': 'phones.' + index + '.country_calling_code' in form.errors }" />
                                                            <input type="text" class="form-control"
                                                                v-model="field.phone"
                                                                v-on:input="removeError(index, 'phone')"
                                                                :placeholder="translate('messages.phone')"
                                                                :class="{ 'is-invalid': 'phones.' + index + '.phone' in form.errors }" />
                                                            <div class="input-group-append">
                                                                <button class="btn btn-danger"
                                                                    @click="removeFormField(index)"><i
                                                                        class="fa fa-trash"></i></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="text-center">
                                                    <button class="btn btn-success pb-2" @click="addFormField"><i
                                                            class="fa fa-plus"></i></button>
                                                </div>
                                            </div>
                                            <div class="card-footer p-1">
                                                <h4>{{ translate('messages.upload_csv_file') }}</h4>
                                                <input type="file" ref="fileInput" @change="selectFile">
                                                <button class="btn btn-secondary" @click="loadFile">{{
                                                    translate('messages.load_file')
                                                }}</button>
                                                <a href="/files/phones_example.csv" target="_BLANK">{{
                                                    translate('messages.download_example')
                                                }}</a>
                                            </div>
                                            <div v-if="loadingPhones" class="overlay dark">
                                                <i class="fas fa-sync fa-spin fa-2x"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="card wa-message">
                                            <div class="card-header">
                                                <h3 class="card-title">{{ translate('messages.message') }}</h3>
                                            </div>
                                            <div class="card-body p-1">
                                                <textarea class="form-control" v-model="message"
                                                    :class="{ 'is-invalid': 'message' in form.errors }"></textarea>
                                            </div>
                                            <div class="card-footer p-1">
                                                <button class="btn btn-secondary" @click="sendMessage">{{
                                                    translate('messages.send')
                                                }}</button>
                                                <span v-if="'message' in form.errors" class="invalid-feedback d-block">{{
                                                    form.errors.message }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="sending" class="overlay dark">
                            <i class="fas fa-sync fa-spin fa-2x"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
  
<script>

export default {
    data() {
        return {
            message: '',
            fields: [{
                country_calling_code: '',
                phone: '',
            }],
            countries: [],
            file: null,
            loadingPhones: true,
            sending: false,
            sent: false,
            form: {
                errors: {}
            }
        };
    },
    mounted() {
        this.loadCountries();
    },
    methods: {
        addFormField() {
            this.fields.push({
                country_calling_code: '',
                phone: '',
            });
            this.form.errors = {};
        },
        removeFormField(index) {
            this.fields.splice(index, 1);
            this.form.errors = {};
        },
        loadCountries() {
            var v = this;
            axios.get("/api/utils/countries").then(({ data }) => {
                var countries = data.data
                $.each(countries, function (index, country) {
                    $.each(country.callingCodes, function (indexC, calling_code) {
                        v.countries.push({
                            label: `${country.name} (+${calling_code})`,
                            key: calling_code
                        });
                    });
                });
                this.loadingPhones = false;
            });
        },
        selectFile(event) {
            this.file = event.target.files[0];
        },
        loadFile() {
            if (!this.file) {
                return;
            }
            this.$Progress.start();
            this.loadingPhones = true
            const formData = new FormData();
            formData.append('file', this.file);
            var v = this;
            axios.post('/api/utils/transformCsv', formData)
                .then(response => {
                    var phones = response.data.data;
                    $.each(phones, function (index, phone) {
                        v.fields.push({
                            country_calling_code: phone.country_calling_code,
                            phone: phone.phone
                        });
                    });
                    this.$Progress.finish();
                    this.loadingPhones = false;
                    this.$refs.fileInput.value = '';
                })
                .catch((error) => {
                    let error_obj = JSON.parse(error.request.response);
                    let error_title = typeof (error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                    if (error_title == 'The given data was invalid.') error_title = window.translate('messages.invalid_data');
                    Toast.fire({
                        icon: 'error',
                        title: error_title
                    });
                    this.$Progress.fail();
                    this.loadingPhones = false;
                    this.$refs.fileInput.value = '';
                })
        },
        sendMessage() {
            Swal.fire({
                title: window.translate('messages.are_you_sure'),
                text: window.translate('messages.send_confirm'),
                showCancelButton: true,
                cancelButtonColor: '#d33',
                confirmButtonColor: '#3085d6',
                cancelButtonText: window.translate('messages.cancel'),
                confirmButtonText: window.translate('messages.send')
            })
                .then((result) => {
                    // Send request to the server
                    if (result.value) {
                        this.$Progress.start();
                        this.sending = true;
                        const data = {
                            phones: this.fields,
                            message: this.message
                        }
                        this.form.errors = {};
                        axios.post('/api/waMessager/sendMessage', data)
                            .then(response => {
                                this.sent = true;
                                this.sending = false;
                                this.$Progress.finish();
                            })
                            .catch((error) => {
                                let error_obj = JSON.parse(error.request.response);
                                this.form.errors = 'errors' in error_obj ? error_obj.errors : {};
                                let error_title = window.translate('messages.error_ocurred');
                                Toast.fire({
                                    icon: 'error',
                                    title: error_title
                                });
                                this.sending = false;
                                this.$Progress.fail();
                            })
                    }
                })
        },
        removeError(index, field) {
            let objKey = `phones.${index}.${field}`;
            delete this.form.errors[objKey];
        },
        resetForm() {
            this.form.errors = {};
            this.fields = [{
                country_calling_code: '',
                phone: '',
            }];
            this.message = '';
            this.sent = false;
        }
    },
};
</script>
  